/**
 * Versioned localStorage helpers. Use version prefix for keys so schema can evolve.
 * All reads/writes are wrapped in try/catch (fails in incognito or when disabled).
 */

const VERSION = 'v1';

const keys = {
  tenantUuid: `tenant_uuid:${VERSION}`,
  userId: `userId:${VERSION}`,
  sidebarWidth: `aiker_sidebar_width:${VERSION}`,
};

export function getStorageItem(key, fallback = null) {
  try {
    const value = localStorage.getItem(key);
    return value !== null ? value : fallback;
  } catch {
    return fallback;
  }
}

export function setStorageItem(key, value) {
  try {
    if (value == null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, String(value));
    }
  } catch {
    // incognito, quota, or disabled
  }
}

export function removeStorageItem(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // incognito, quota, or disabled
  }
}

export function getTenantUuid() {
  return getStorageItem(keys.tenantUuid) || getStorageItem('tenant_uuid') || null;
}

export function setTenantUuid(value) {
  setStorageItem(keys.tenantUuid, value);
  setStorageItem('tenant_uuid', value);
}

export function getUserId() {
  return getStorageItem(keys.userId) || getStorageItem('userId') || null;
}

export function setUserId(value) {
  setStorageItem(keys.userId, value);
  setStorageItem('userId', value);
}

export function clearTenantSessionStorage() {
  removeStorageItem(keys.tenantUuid);
  removeStorageItem('tenant_uuid');
  removeStorageItem('tenant_name');
  removeStorageItem(keys.userId);
  removeStorageItem('userId');
}

export function getSidebarWidth(fallback = 280) {
  const raw = getStorageItem(keys.sidebarWidth) || getStorageItem('aiker_sidebar_width');
  if (raw == null) return fallback;
  const n = parseInt(raw, 10);
  return Number.isNaN(n) ? fallback : n;
}

export function setSidebarWidth(value) {
  const n = Number(value);
  if (!Number.isNaN(n)) {
    setStorageItem(keys.sidebarWidth, n);
    setStorageItem('aiker_sidebar_width', n);
  }
}

export { keys };
